import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {AsyncStatusesEnum} from '../../../../../../libs/shared/helpers/src/types/asyncStatuses';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {center} from '../../../../../../libs/shared/ui/src/styles/mixins';
import {HttpResponseError} from '../../../../../services/http/httpError';
import {AsyncLoader} from '../../../../common/loaders/asyncLoader';

/*
 * Props.
 */

interface DraftAssistantLoaderProps {
  loadingStatus: AsyncStatusesEnum.LOADING | AsyncStatusesEnum.FAILED;
  onRetryClick: Handler;
  loadingMessage: ReactNode;
  error?: HttpResponseError;
}

/*
 * Styles.
 */

const StyledLoaderContainerDiv = styled.div`
  padding: 12px 0px;
`;

const StyledLoaderTextDiv = styled.div`
  font-weight: ${fontWeights.medium};
  ${center()};
  margin-bottom: 12px;
`;

/*
 * Component.
 */

export const DraftAssistantLoader: FC<DraftAssistantLoaderProps> = (props) => {
  const {error, loadingMessage, loadingStatus, onRetryClick} = props;

  return (
    <StyledLoaderContainerDiv>
      {loadingStatus === AsyncStatusesEnum.LOADING && (
        <StyledLoaderTextDiv>{loadingMessage}</StyledLoaderTextDiv>
      )}
      <AsyncLoader
        status={loadingStatus}
        size={VisualSizesEnum.MEDIUM}
        onRetryClick={onRetryClick}
        error={renderErrorMessage(error)}
      />
    </StyledLoaderContainerDiv>
  );
};

function renderErrorMessage(error: HttpResponseError | undefined) {
  switch (error?.status) {
    case 429:
      return <Trans id="draft-assistant-rate-limit-error">Too many requests - please try again later.</Trans>;
    case 400:
      return <Trans id="draft-assistant-bad-request-error">Something went wrong.</Trans>;
    default:
      return <Trans id="draft-assistant-generic-error">Something went wrong. Please try again.</Trans>;
  }
}
